import { render, staticRenderFns } from "./Products_Reasons.vue?vue&type=template&id=002c8540"
import script from "./Products_Reasons.vue?vue&type=script&lang=js"
export * from "./Products_Reasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports